import { Design, Shop } from '@/types';
import { isMdsPriceStrategy } from './isMdsPriceStrategy';

export const isOwnerOfShopAndDesign = (context: Shop, design: Design) =>
  isMdsPriceStrategy(context.priceStrategy) &&
  context.user &&
  design.user &&
  context.user.id === design.user.id;
